import { render, staticRenderFns } from "./goodsEvaluateDialog.vue?vue&type=template&id=88632b82&scoped=true"
import script from "./goodsEvaluateDialog.vue?vue&type=script&lang=js"
export * from "./goodsEvaluateDialog.vue?vue&type=script&lang=js"
import style0 from "./goodsEvaluateDialog.vue?vue&type=style&index=0&id=88632b82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88632b82",
  null
  
)

export default component.exports